export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  description: string;
  rating: number;
  views: number;
  chapters: number;
  status: string;
  updateDate: string;
  tags: string[];
  chapters_list: Chapter[];
}

export interface Chapter {
  id: number;
  title: string;
  updateDate: string;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '女神降临',
    author: '猫咪作家',
    category: 'lianai-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20applying%20makeup%20at%20a%20vanity%20mirror%20soft%20romantic%20atmosphere%20warm%20lighting%20clean%20background%20manga%20style%20art%20professional%20quality&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '长相平凡的女高中生通过化妆变身校园女神，展开了一段充满欢笑与泪水的青春成长故事。当她遇到两位截然不同的男生，一场关于外貌、自卑与真爱的故事就此展开。',
    rating: 4.8,
    views: 12800000,
    chapters: 156,
    status: '连载中',
    updateDate: '2026-08-03',
    tags: ['恋爱', '校园', '成长', '化妆'],
    chapters_list: [
      { id: 1, title: '第1话 化妆的魔法', updateDate: '2024-01-15' },
      { id: 2, title: '第2话 校园新星', updateDate: '2024-01-22' },
      { id: 3, title: '第3话 意外的相遇', updateDate: '2024-01-29' },
      { id: 4, title: '第4话 心跳加速', updateDate: '2024-02-05' },
      { id: 5, title: '第5话 秘密被发现', updateDate: '2024-02-12' },
      { id: 6, title: '第6话 两个男生', updateDate: '2024-02-19' },
      { id: 7, title: '第7话 图书馆的午后', updateDate: '2024-02-26' },
      { id: 8, title: '第8话 校园祭', updateDate: '2024-03-04' },
    ],
  },
  {
    id: 2,
    title: '我独自升级',
    author: 'DUBU',
    category: 'dongzuo-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20illustration%20of%20a%20powerful%20male%20hunter%20with%20dark%20armor%20and%20glowing%20blue%20eyes%20standing%20in%20a%20dungeon%20gate%20dramatic%20lighting%20intense%20atmosphere%20clean%20manga%20art%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '在一个充满怪物的世界中，被称为"人类最弱兵器"的成振宇，在一次濒死经历后获得了独特的"升级"系统。从此他踏上了一条不断变强的道路，挑战各种强大敌人。',
    rating: 4.9,
    views: 25600000,
    chapters: 200,
    status: '已完结',
    updateDate: '2026-07-28',
    tags: ['动作', '奇幻', '升级', '热血'],
    chapters_list: [
      { id: 1, title: '第1话 最弱的猎人', updateDate: '2023-06-10' },
      { id: 2, title: '第2话 双重地下城', updateDate: '2023-06-17' },
      { id: 3, title: '第3话 系统觉醒', updateDate: '2023-06-24' },
      { id: 4, title: '第4话 每日任务', updateDate: '2023-07-01' },
      { id: 5, title: '第5话 第一次升级', updateDate: '2023-07-08' },
      { id: 6, title: '第6话 新手地下城', updateDate: '2023-07-15' },
      { id: 7, title: '第7话 BOSS战', updateDate: '2023-07-22' },
      { id: 8, title: '第8话 实力飞跃', updateDate: '2023-07-29' },
    ],
  },
  {
    id: 3,
    title: '甜蜜家园',
    author: '金坎比',
    category: 'xuanyi-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20horror%20thriller%20illustration%20of%20an%20apartment%20building%20at%20night%20with%20ominous%20monster%20shadows%20creeping%20in%20hallways%20dark%20atmosphere%20survival%20theme%20clean%20manga%20art%20professional%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '在经历个人悲剧后，高中生车贤秀搬到了一栋老旧公寓。当一种神秘病毒将人们变成可怕的怪物时，公寓里的居民们必须团结起来，在绝望中为生存而战。',
    rating: 4.7,
    views: 18900000,
    chapters: 141,
    status: '已完结',
    updateDate: '2026-07-20',
    tags: ['悬疑', '恐怖', '生存', '人性'],
    chapters_list: [
      { id: 1, title: '第1话 搬入新家', updateDate: '2023-03-01' },
      { id: 2, title: '第2话 奇怪的邻居', updateDate: '2023-03-08' },
      { id: 3, title: '第3话 公寓封锁', updateDate: '2023-03-15' },
      { id: 4, title: '第4话 第一个怪物', updateDate: '2023-03-22' },
      { id: 5, title: '第5话 幸存者集合', updateDate: '2023-03-29' },
      { id: 6, title: '第6话 人性的考验', updateDate: '2023-04-05' },
      { id: 7, title: '第7话 深夜突袭', updateDate: '2023-04-12' },
      { id: 8, title: '第8话 怪物的秘密', updateDate: '2023-04-19' },
    ],
  },
  {
    id: 4,
    title: '金秘书为何那样',
    author: '郑景允',
    category: 'lianai-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20office%20illustration%20of%20a%20confident%20female%20secretary%20in%20a%20modern%20office%20with%20a%20handsome%20CEO%20in%20background%20warm%20romantic%20lighting%20professional%20manga%20style%20art&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '能力出众的金秘书在副会长身边工作了九年之后，突然提出辞职。这让一直依赖她的副会长李英俊措手不及，为了挽留她，他开始了一场别开生面的"求婚大作战"。',
    rating: 4.6,
    views: 15200000,
    chapters: 98,
    status: '已完结',
    updateDate: '2026-07-15',
    tags: ['恋爱', '职场', '喜剧', '总裁'],
    chapters_list: [
      { id: 1, title: '第1话 完美的秘书', updateDate: '2024-05-01' },
      { id: 2, title: '第2话 突如其来的辞职', updateDate: '2024-05-08' },
      { id: 3, title: '第3话 会长的困惑', updateDate: '2024-05-15' },
      { id: 4, title: '第4话 九年的回忆', updateDate: '2024-05-22' },
      { id: 5, title: '第5话 挽留计划', updateDate: '2024-05-29' },
      { id: 6, title: '第6话 意外的告白', updateDate: '2024-06-05' },
      { id: 7, title: '第7话 心跳的约会', updateDate: '2024-06-12' },
      { id: 8, title: '第8话 家族反对', updateDate: '2024-06-19' },
    ],
  },
  {
    id: 5,
    title: '狂野少女',
    author: '金明熙',
    category: 'lianai-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20illustration%20of%20a%20rebellious%20high%20school%20girl%20with%20short%20hair%20and%20a%20studious%20boy%20in%20school%20uniform%20cherry%20blossom%20background%20youthful%20romantic%20manga%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '性格火爆的不良少女韩夏天与全校第一的模范生李书俊被迫成为同桌。水火不容的两人在日常相处中慢慢了解彼此，一段欢喜冤家的青春恋曲就此奏响。',
    rating: 4.5,
    views: 9800000,
    chapters: 120,
    status: '连载中',
    updateDate: '2026-08-02',
    tags: ['恋爱', '校园', '欢喜冤家', '青春'],
    chapters_list: [
      { id: 1, title: '第1话 不良少女驾到', updateDate: '2024-08-01' },
      { id: 2, title: '第2话 冤家同桌', updateDate: '2024-08-08' },
      { id: 3, title: '第3话 图书馆对决', updateDate: '2024-08-15' },
      { id: 4, title: '第4话 放学后的秘密', updateDate: '2024-08-22' },
      { id: 5, title: '第5话 意外的关心', updateDate: '2024-08-29' },
      { id: 6, title: '第6话 校运会风波', updateDate: '2024-09-05' },
      { id: 7, title: '第7话 雨天的告白', updateDate: '2024-09-12' },
      { id: 8, title: '第8话 心跳的距离', updateDate: '2024-09-19' },
    ],
  },
  {
    id: 6,
    title: '他人即地狱',
    author: '金容基',
    category: 'xuanyi-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20psychological%20thriller%20illustration%20of%20a%20dark%20narrow%20alleyway%20in%20Seoul%20at%20night%20with%20mysterious%20figures%20lurking%20in%20shadows%20tense%20suspenseful%20manga%20style%20art%20clean%20dark%20atmosphere&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '从乡下来到首尔打拼的年轻人尹钟宇，因为经济拮据住进了一家廉价的考试院。然而这里的住客们一个比一个诡异，一场恐怖的心理游戏悄然展开。',
    rating: 4.7,
    views: 11000000,
    chapters: 58,
    status: '已完结',
    updateDate: '2026-06-30',
    tags: ['悬疑', '恐怖', '心理', '惊悚'],
    chapters_list: [
      { id: 1, title: '第1话 首尔的考试院', updateDate: '2024-10-01' },
      { id: 2, title: '第2话 奇怪的邻居们', updateDate: '2024-10-08' },
      { id: 3, title: '第3话 深夜的声响', updateDate: '2024-10-15' },
      { id: 4, title: '第4话 失踪的房客', updateDate: '2024-10-22' },
      { id: 5, title: '第5话 牙医诊所', updateDate: '2024-10-29' },
      { id: 6, title: '第6话 诡异的气氛', updateDate: '2024-11-05' },
      { id: 7, title: '第7话 无法逃离', updateDate: '2024-11-12' },
      { id: 8, title: '第8话 真相浮现', updateDate: '2024-11-19' },
    ],
  },
  {
    id: 7,
    title: '便利店新星',
    author: '活跃',
    category: 'gaoxiao-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20comedy%20illustration%20of%20a%20lively%20convenience%20store%20at%20night%20with%20a%20quirky%20female%20clerk%20and%20a%20serious%20manager%20bright%20neon%20lights%20funny%20expressions%20clean%20manga%20art%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '曾经的不良少女丁新星为了追到自己暗恋的便利店店长崔大贤，应聘成为便利店夜班店员。她用自己的方式守护着这家店和心爱的人，欢乐又温暖的日常故事。',
    rating: 4.4,
    views: 8700000,
    chapters: 85,
    status: '已完结',
    updateDate: '2026-06-15',
    tags: ['搞笑', '恋爱', '日常', '治愈'],
    chapters_list: [
      { id: 1, title: '第1话 奇怪的应聘者', updateDate: '2024-11-01' },
      { id: 2, title: '第2话 夜班第一天', updateDate: '2024-11-08' },
      { id: 3, title: '第3话 醉汉的挑战', updateDate: '2024-11-15' },
      { id: 4, title: '第4话 店长的秘密', updateDate: '2024-11-22' },
      { id: 5, title: '第5话 便利店的日常', updateDate: '2024-11-29' },
      { id: 6, title: '第6话 意外的温柔', updateDate: '2024-12-06' },
      { id: 7, title: '第7话 同事的助攻', updateDate: '2024-12-13' },
      { id: 8, title: '第8话 心动的瞬间', updateDate: '2024-12-20' },
    ],
  },
  {
    id: 8,
    title: '剑尊归来',
    author: '李道韩',
    category: 'qihuan-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20martial%20arts%20illustration%20of%20a%20legendary%20swordsman%20in%20traditional%20robes%20holding%20a%20glowing%20sword%20standing%20on%20a%20mountain%20peak%20at%20dawn%20epic%20atmosphere%20clean%20manga%20art%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '天下第一剑尊在修炼千年后意外重生回少年时代。带着前世的记忆和绝世剑法，他决心改写命运，守护那些曾经失去的人。一部热血与柔情并存的奇幻武侠巨作。',
    rating: 4.9,
    views: 21300000,
    chapters: 178,
    status: '连载中',
    updateDate: '2026-08-01',
    tags: ['奇幻', '武侠', '重生', '热血'],
    chapters_list: [
      { id: 1, title: '第1话 千年剑尊', updateDate: '2024-02-01' },
      { id: 2, title: '第2话 意外重生', updateDate: '2024-02-08' },
      { id: 3, title: '第3话 少年时代', updateDate: '2024-02-15' },
      { id: 4, title: '第4话 家族的危机', updateDate: '2024-02-22' },
      { id: 5, title: '第5话 初露锋芒', updateDate: '2024-03-01' },
      { id: 6, title: '第6话 宗门大比', updateDate: '2024-03-08' },
      { id: 7, title: '第7话 龙吟剑法', updateDate: '2024-03-15' },
      { id: 8, title: '第8话 暗流涌动', updateDate: '2024-03-22' },
    ],
  },
  {
    id: 9,
    title: '外貌至上主义',
    author: '朴泰俊',
    category: 'dushi-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20illustration%20of%20an%20overweight%20high%20school%20student%20looking%20at%20his%20handsome%20reflection%20in%20a%20mirror%20split%20image%20contrast%20emotional%20atmosphere%20clean%20manga%20art%20professional%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '因为外貌长期遭受校园霸凌的朴亨锡，在某天醒来后发现自己有了另一副完美身躯。白天是校园偶像，夜晚变回原来的自己，在双重生活中他逐渐明白了真正重要的东西。',
    rating: 4.6,
    views: 16500000,
    chapters: 200,
    status: '已完结',
    updateDate: '2026-05-20',
    tags: ['都市', '校园', '成长', '社会'],
    chapters_list: [
      { id: 1, title: '第1话 被霸凌的少年', updateDate: '2023-08-01' },
      { id: 2, title: '第2话 完美身躯', updateDate: '2023-08-08' },
      { id: 3, title: '第3话 新校园生活', updateDate: '2023-08-15' },
      { id: 4, title: '第4话 两个身份', updateDate: '2023-08-22' },
      { id: 5, title: '第5话 网络主播', updateDate: '2023-08-29' },
      { id: 6, title: '第6话 过去的阴影', updateDate: '2023-09-05' },
      { id: 7, title: '第7话 友情的力量', updateDate: '2023-09-12' },
      { id: 8, title: '第8话 真正的勇气', updateDate: '2023-09-19' },
    ],
  },
  {
    id: 10,
    title: '顶级明星',
    author: '赵石',
    category: 'dushi-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20showbiz%20illustration%20of%20a%20young%20male%20celebrity%20on%20a%20red%20carpet%20with%20cameras%20flashing%20glamorous%20atmosphere%20dramatic%20lighting%20clean%20manga%20art%20professional%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '默默无闻的练习生李泰浩在出道前夕遭遇意外，却因祸得福获得了影帝级别的演技系统。从此他的演艺之路一帆风顺，但成名背后隐藏的秘密也渐渐浮出水面。',
    rating: 4.5,
    views: 7800000,
    chapters: 92,
    status: '连载中',
    updateDate: '2026-08-02',
    tags: ['都市', '娱乐圈', '系统', '成长'],
    chapters_list: [
      { id: 1, title: '第1话 最后一次机会', updateDate: '2025-01-10' },
      { id: 2, title: '第2话 演技系统', updateDate: '2025-01-17' },
      { id: 3, title: '第3话 试镜奇迹', updateDate: '2025-01-24' },
      { id: 4, title: '第4话 初登荧幕', updateDate: '2025-01-31' },
      { id: 5, title: '第5话 新人奖提名', updateDate: '2025-02-07' },
      { id: 6, title: '第6话 竞争对手', updateDate: '2025-02-14' },
      { id: 7, title: '第7话 绯闻风波', updateDate: '2025-02-21' },
      { id: 8, title: '第8话 影帝的秘密', updateDate: '2025-02-28' },
    ],
  },
  {
    id: 11,
    title: '复学日',
    author: '李慧',
    category: 'dushi-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20life%20illustration%20of%20a%20young%20man%20returning%20to%20high%20school%20campus%20after%20a%20long%20absence%20autumn%20leaves%20nostalgic%20warm%20atmosphere%20clean%20manga%20art%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '因病休学两年的金智勋重返校园后，发现一切都变了。曾经的好友已升入高三，他要重新适应校园生活，还要面对那些曾经熟悉又陌生的面孔。',
    rating: 4.3,
    views: 5600000,
    chapters: 65,
    status: '连载中',
    updateDate: '2026-07-30',
    tags: ['都市', '校园', '友情', '青春'],
    chapters_list: [
      { id: 1, title: '第1话 重返校园', updateDate: '2025-05-01' },
      { id: 2, title: '第2话 陌生的教室', updateDate: '2025-05-08' },
      { id: 3, title: '第3话 旧友重逢', updateDate: '2025-05-15' },
      { id: 4, title: '第4话 新的开始', updateDate: '2025-05-22' },
      { id: 5, title: '第5话 课堂风波', updateDate: '2025-05-29' },
      { id: 6, title: '第6话 社团招新', updateDate: '2025-06-05' },
      { id: 7, title: '第7话 运动会', updateDate: '2025-06-12' },
      { id: 8, title: '第8话 夏天的约定', updateDate: '2025-06-19' },
    ],
  },
  {
    id: 12,
    title: '花书生恋爱史',
    author: '金恩淑',
    category: 'gufeng-manhua',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20historical%20romance%20illustration%20of%20a%20scholar%20in%20traditional%20Korean%20hanbok%20reading%20under%20a%20cherry%20blossom%20tree%20with%20a%20beautiful%20woman%20nearby%20ancient%20Korea%20setting%20elegant%20clean%20manga%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '朝鲜时代，一位才华横溢的落榜书生与女扮男装的贵族小姐在书院相遇。两人在诗书礼乐中暗生情愫，却因身份差异和时代束缚面临重重阻碍。',
    rating: 4.7,
    views: 7200000,
    chapters: 76,
    status: '已完结',
    updateDate: '2026-04-10',
    tags: ['古风', '恋爱', '历史', '女扮男装'],
    chapters_list: [
      { id: 1, title: '第1话 书院新来的学子', updateDate: '2025-03-01' },
      { id: 2, title: '第2话 诗会初遇', updateDate: '2025-03-08' },
      { id: 3, title: '第3话 深夜论学', updateDate: '2025-03-15' },
      { id: 4, title: '第4话 月色下的秘密', updateDate: '2025-03-22' },
      { id: 5, title: '第5话 花灯节', updateDate: '2025-03-29' },
      { id: 6, title: '第6话 身份暴露', updateDate: '2025-04-05' },
      { id: 7, title: '第7话 科举之路', updateDate: '2025-04-12' },
      { id: 8, title: '第8话 红袖添香', updateDate: '2025-04-19' },
    ],
  },
];

export const getComicById = (id: number): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return comics.filter((c) => c.category === categorySlug);
};

export const getHotComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, limit);
};